const RCS = {
    PREFIX_API: `/api`,
    LIST_SCHOOL: `/ls`,
    SCHOOL_DETAIL: `/sd`,
    SCHOOL_ADDRESS: `/sa`,
    SCHOOL_STAFFS: `/ss`,
    SCHOOL_ENROLLMENT: `/se`,
    SCHOOL_INFRASTRUCTURE: `/si`,
    SCHOOL_LINKS: `/sl`,
    SCHOOL_OTHER: `/so`,
    SCHOOL_OUTSTANDING:'/sos'
}

export { RCS }
